import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { rootRoute } from '../../../config';
import info from '../assets/info.png';
import time_elapse_icon from '../../../assets/time_elapse_icon.png';
import Button from '../../common/Button'
import ScmModuleStyle from '../styles/scm.module.css';

const SimProgress = ({ popupState, actions }) => {
  const navigate = useNavigate();
  const [playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation,isShowRequestBid] = actions;
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error,isRequestLoading, scmPopup, setScmPopup,viewBidsPopup,setViewBidsPopup] = popupState;
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalDuration = 10; // 1 second in milliseconds
  const totalTime = 100; // Total time in seconds
  const isLeapYear = (year) => {
    return ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) ? 366 : 365;
  }
  const progressbar = { "valuemin": 0, "valuemax": isLeapYear(simObj?.laststate?.stateyear), "valuenow": function () { return (Math.round((simObj.currentstep / this.valuemax) * 100)) } }
  const showSummary = () => {
    setIsLoader(true);
    navigate(rootRoute + "/scm/summary");
  }
  const getShortMonth = (month) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
    return months[month - 1];
  }
  useEffect(()=>{((toggleSimulation) && simObj.status != 'COMPLETED' && error == null && currentTime == totalTime) && resumeSimulation();},[currentTime])
  useEffect(()=>{!isRequestLoading &&  setCurrentTime(0);},[isRequestLoading])
  useEffect(() => {
    let intervalId;
    if (isPlaying && currentTime < totalTime) {
      intervalId = setInterval(() => {
        setCurrentTime((prevTime) => prevTime + 1);
      }, intervalDuration);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isPlaying, currentTime, totalTime]);

  useEffect(()=>{(toggleSimulation) ? setIsPlaying(true) : setIsPlaying(false);},[toggleSimulation]);
  useEffect(() => {
    if (document.querySelector(`.${ScmModuleStyle.simProg}`) != null && window.innerWidth > 991) {
      let top = 0;
      if (document.querySelector(`.${ScmModuleStyle['sim-progress-activity']} .${ScmModuleStyle.posuccess}`) != null) {
        // top = document.querySelector(`.${ScmModuleStyle._progress}`).clientHeight + document.querySelector(`.${ScmModuleStyle.posuccess}`).clientHeight+12;
        top = 100;
        document.querySelector(`.${ScmModuleStyle.ui}.${ScmModuleStyle.pointing}.${ScmModuleStyle.label}.${ScmModuleStyle.simProg}`).style.top = top + "%";
      }
      else {
        top = document.querySelector(`.${ScmModuleStyle._progress}`).clientHeight + document.querySelector(`.${ScmModuleStyle._progress}`).offsetTop;
        document.querySelector(`.${ScmModuleStyle.ui}.${ScmModuleStyle.pointing}.${ScmModuleStyle.label}.${ScmModuleStyle.simProg}`).style.top = top + "px";
      }
    }
    if (document.querySelector(`.${ScmModuleStyle['sim-progress-activity']} .${ScmModuleStyle.posuccess}`) != null && window.innerWidth < 991 && document.querySelector(`.${ScmModuleStyle.simProg}`) != null) {
      document.querySelector(`.${ScmModuleStyle.ui}.${ScmModuleStyle.pointing}.${ScmModuleStyle.label}.${ScmModuleStyle.simProg}`).style.left = "20%";
    }
  }, [simPrgPopup]);
  useEffect(()=>{
    if((simObj.status == 'COMPLETED') && (document.getElementById("showSummary") != null)){
      document.getElementById("showSummary").focus();
    }
  },[simObj.status])
  return (
    <div className={`${ScmModuleStyle['sim-progress-activity']}`}>
      <div className={`${ScmModuleStyle['progress-pie-container']} ${scmPopup?.simProgPopup ? `show ${ScmModuleStyle['show']}` : ''}`}>
        <div className={`${ScmModuleStyle.pie}`} title={`${currentTime}% completed.`} style={{ '--p': (simObj.status == 'COMPLETED') ? 100 : currentTime, '--b': '10px', '--c': 'purple' }} role='progressbar'></div>
        <div className={`${ScmModuleStyle._progress} ${simPrgPopup ? `show ${ScmModuleStyle.show}` : ''}`}>
          <div className={`${ScmModuleStyle['time-progress']}`}>
            <div className={`${ScmModuleStyle['remain-time']}`}>
              {/* <img className={(toggleSimulation && simObj.status != 'COMPLETED') ? `${ScmModuleStyle.spin}` : ''} src={time_elapse_icon} alt="" /> */}
              <span><strong>{getShortMonth(simObj?.laststate?.statemonth)} {simObj?.laststate?.stateday} </strong>({simObj?.laststate?.weekleft} weeks remaining)</span>
              <span className="sr-only" role="status" aria-live="polite">
                {`${getShortMonth(simObj?.laststate?.statemonth)} ${simObj?.laststate?.stateday} (${simObj?.laststate?.weekleft} weeks remaining)`}
              </span>
            </div>
            <div className={`ui progress indicating ${ScmModuleStyle.progress} ${ScmModuleStyle.ui}`}>
              <div className={`${ScmModuleStyle['background']}`} id="time">
                <div role="progressbar"
                  aria-valuenow={progressbar.valuenow()}
                  aria-valuemin={progressbar.valuemin}
                  aria-valuemax={progressbar.valuemax}
                  aria-valuetext={`${progressbar.valuenow()}%`}
                  className={` ${ScmModuleStyle['progress-fg']} ${(toggleSimulation && simObj.status != 'COMPLETED') ? `${ScmModuleStyle.active}` : ''}`} style={{ "width": progressbar.valuenow() + '%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
        {
          (toggleSimulation && simObj.status != 'COMPLETED') && <Button btnName="Pause Simulation" clickEventHandler={pauseSimulation} btnId="pauseSumButton" />
        }{
          (!toggleSimulation && simObj.status != 'COMPLETED') && <Button disabled={(simObj.laststate?.quantityordered == 0 && simObj?.currentstep == 0) ? true : false} btnName={simObj.currentstep == 0 ? 'Start Simulation' : 'Resume Simulation'} clickEventHandler={playSimulation} btnId="playSumButton" />
        }{
          (simObj.status == 'COMPLETED') && <Button btnName="Show Summary" clickEventHandler={showSummary} btnId="showSummary" />
        }

        {
          scmPopup?.simProgPopup ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['sim-progress-popup']}`} role='dialog' aria-modal="true" aria-label="Simulation progress popup" tabIndex={-1}>
            <p>The time will automatically start running as you wait for bids to come in. If you want to pause/resume the simulation at any point, click the button. Note: Checking your documents will automatically pause the simulation so you will need to click Resume.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['simProgPopup'] : false}));
                setViewBidsPopup(true);
              }} />
            </div>
          </div> : ''
        }
      <div className={`${ScmModuleStyle['simmsg-container']}`}>
        {
          (simObj?.currentstep != 1) ? (
            ((!toggleSimulation && simObj.status != 'COMPLETED') && isShowRequestBid)
              || ((toggleSimulation && simObj.status != 'COMPLETED') && !isShowRequestBid) 
            //  || (simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming)
            //  || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowRequestBid && (simObj.status == 'COMPLETED'))) && 
            ) ? <div className={`ui success message ${ScmModuleStyle.ui} ${ScmModuleStyle.success} ${ScmModuleStyle.message} ${ScmModuleStyle.simmsg}`}>
            <div role='alert'>
              { 
                (toggleSimulation && simObj.status != 'COMPLETED') && (<><img src={info} alt="info" /><p>{`Pause the simulation to request bids or place orders.`}</p></>)
              }
              {
                (!toggleSimulation  && isShowRequestBid) && (<><img src={info} alt="info" /><p className='placeorder-msg'>{`Your bid requests are saved, please click on ${simObj?.currentstep > 0 ? 'Resume' : 'Start'} Simulation to continue.`}</p></>)
              }
              {                
                (simObj.status != 'COMPLETED') &&  simObj.currentstep != 0 && (!(toggleSimulation) && !(isShowRequestBid) &&  simObj?.laststate?.investmentOptions?.isUpcomming) && (<><img src={info} alt="info" /><p>{`Please review and make investment decisions, after submitting decisions click on Resume Simulation.`}</p></>)
              }
              {
                (simObj.status == 'COMPLETED') && (<><img src={info} alt="info" /><p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p></>)
              }
            </div>
          </div> : (simObj.status == 'COMPLETED') && <div className={`ui success message ${ScmModuleStyle.ui} ${ScmModuleStyle.success} ${ScmModuleStyle.message} ${ScmModuleStyle.simmsg}`}>
            <div role='alert'>
              {
                 (<><img src={info} alt="info" /><p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p></>)
              }
            </div>
          </div> : (simObj?.status != 'COMPLETED' && simObj?.currentstep == 1) ? <div className={`ui success message ${ScmModuleStyle.ui} ${ScmModuleStyle.success} ${ScmModuleStyle.message} ${ScmModuleStyle.simmsg}`}>
                  <div role='alert'>
                    {
                      (<><img src={info} alt="info" /><p>{`Simulation is started.`}</p></>)
                    }
                  </div>
            </div> : ''
        }
      </div>
    </div>
  )
}

export default SimProgress